import { gql } from '@apollo/client';

export const CONTENT_TYPE_LIST_QUERY = gql`
  query contentTypeList($pager: PagerInputNew, $filters: ContentTypeListFilters) {
    contentTypeList(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        code
        isFileType
      }
    }
  }
`;
